.scroll {
  max-height: 60vh;
  max-width: 100%;
  min-width: 0;
  overflow-y: auto;
  overflow-x: auto;
  overflow-wrap: anywhere;
}

.scroll :global(img) {
  max-width: 100%;
  height: auto;
}

.scroll :global(table) {
  max-width: 100%;
}

.error {
  color: var(--red-7);
}
